export enum TFeatureFlagType {
  PET_DIRECTORY = 'Pet Directory',
  COMMUNITY_FUND = 'Community Fund',
  COUPON = 'Coupon',
  MESSAGING = 'Messaging',
  MODERATOR = 'https://testing-admin.onesimplicity.com/moderator',
  REPORT_A_PROBLEM = 'ReportAProblem',
}
